import { Box, Typography } from "@mui/material";
import React from "react";
import DynamicTable from "../../../components/DynamicTable";

const headerData1 = ["Hair & Styling", "Total Cost"];
const tableRows = ["service", "price_usd"];

function AllSubscriber({ data }) {
  return (
    <Box>
      <Typography mb={2} variant="h3" fontWeight={700} fontSize={"1.125rem"}>
        Service and Sales
      </Typography>
      <DynamicTable
        minWidth={600}
        tableHeader={headerData1}
        displayRows={tableRows}
        tableData={data || []}
        showPagination={false}
      />
    </Box>
  );
}

export default AllSubscriber;
